/* src/app/system-utils/carousel/carousel-slide/carousel-slide.component.scss */
.carousel-slide {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.carousel-slide-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: auto;
}
.carousel-slide-content {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}
/*# sourceMappingURL=carousel-slide.component.css.map */
